'use strict';

var ResponsiveVideo = {
    CLASS: 'dm-responsive-video',
    INITIALIZED_CLASS: 'dm-responsive-video-initialized',
    ASSET: 'asset',
    DATA_ASSET: 'data-asset',
    ID: 'id',
    POSTER_IMAGE: 'posterimage',
    DATA_POSTER_IMAGE: 'data-posterimage',
    CONFIG: 'config',
    DATA_CONFIG: 'data-config',
    VIDEOVIEWER_URL: 'https://rituals.scene7.com/s7viewers/html5/VideoViewer.html',
    VIDEO_FIRST_PART: 'rituals/',
    DEFAULT_LINKS_CONFIG: {
        'serverurl': 'https://rituals.scene7.com/is/image/',
        'contenturl': 'https://rituals.scene7.com/is/content/',
        'videoserverurl': 'https://rituals.scene7.com/is/content',
        'config': 'rituals/Video'
    },
    DEFAULT_CONFIG: {
        'loop': '1',
        'autoplay': '1',
        'mutevolume': '1',
        'singleclick': 'none',
        'waiticon': '0',
        'initialBitrate': '3000',
        'playback': 'progressive'
    },
    IS_LOADED: false,
    INITIALIZED_ELEMENTS: {},
    init: function init(isLazy) {
        Array.prototype.forEach.call(document.getElementsByClassName(ResponsiveVideo.CLASS), function (element) {
            if (!element.classList.contains(ResponsiveVideo.INITIALIZED_CLASS) && (!isLazy || isLazy && ResponsiveVideo.isElementInViewport(element))) {
                element.classList.add(ResponsiveVideo.INITIALIZED_CLASS);
                ResponsiveVideo.initializeElement(element);
            }
        });
    },
    isElementInViewport: function isElementInViewport(element) {
        //Load all videos within 1.5 screen heights
        var rect = element.getBoundingClientRect();
        return rect.top >= 0 && rect.left >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 1.5 && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    },
    initializeElement: function initializeElement(element, onInitCallback) {
        if (!element) {
            return;
        }

        var customConfig = ResponsiveVideo.getAssetConfig(element);
        var params = {...ResponsiveVideo.DEFAULT_CONFIG, ...ResponsiveVideo.DEFAULT_LINKS_CONFIG, ...customConfig};
        params[ResponsiveVideo.ASSET] = ResponsiveVideo.getAssetSource(element.dataset[ResponsiveVideo.ASSET], ResponsiveVideo.ASSET)
            || ResponsiveVideo.getAssetSource(customConfig[ResponsiveVideo.ASSET], ResponsiveVideo.ASSET);
        params[ResponsiveVideo.POSTER_IMAGE] = ResponsiveVideo.getAssetSource(element.dataset[ResponsiveVideo.POSTER_IMAGE], ResponsiveVideo.POSTER_IMAGE)
            || ResponsiveVideo.getAssetSource(customConfig[ResponsiveVideo.POSTER_IMAGE], ResponsiveVideo.POSTER_IMAGE)
            || ResponsiveVideo.getAssetSource(element.dataset[ResponsiveVideo.ASSET], ResponsiveVideo.POSTER_IMAGE)
            || ResponsiveVideo.getAssetSource(customConfig[ResponsiveVideo.ASSET], ResponsiveVideo.POSTER_IMAGE)
            || params[ResponsiveVideo.ASSET];

        if ( (/iP(ad|od|hone)/i.test(navigator.userAgent) || /Mac|Macintosh/i.test(navigator.userAgent)) &&
		    /WebKit/i.test(navigator.userAgent) && !(/(Chrome|CriOS|FxiOS|OPiOS|mercury|Firefox)/i.test(navigator.userAgent))) {
            params.playback = 'progressive';
        }

        if (!element.id) {
            element.setAttribute(ResponsiveVideo.ID, ResponsiveVideo.CLASS + '-' + new Date().getTime());
        }

        ResponsiveVideo.loadVideo(element, element.id, params, onInitCallback);
    },
    renitializeElement: function updateElement(element, config, onInitCallback) {
        if (!element) {
            return;
        }

        element.removeAttribute(ResponsiveVideo.DATA_ASSET);
        element.removeAttribute(ResponsiveVideo.DATA_POSTER_IMAGE);
        element.removeAttribute(ResponsiveVideo.DATA_CONFIG);
        if (typeof config === 'object' && config !== null) {
            var asset = config[ResponsiveVideo.ASSET];
            delete config[ResponsiveVideo.ASSET];
            var posterimage = config[ResponsiveVideo.POSTER_IMAGE];
            delete config[ResponsiveVideo.POSTER_IMAGE];
            element.setAttribute(ResponsiveVideo.DATA_CONFIG, JSON.stringify(config));
            if (asset) {
                element.setAttribute(ResponsiveVideo.DATA_ASSET, asset);
            }
            if (posterimage) {
                element.setAttribute(ResponsiveVideo.DATA_POSTER_IMAGE, posterimage);
            }
        }

        ResponsiveVideo.initializeElement(element, onInitCallback);
    },
    loadVideo(element, containerId, params, onInitCallback) {
        var s7videoviewer = null;
        if (ResponsiveVideo.INITIALIZED_ELEMENTS[containerId]) {
            s7videoviewer = ResponsiveVideo.INITIALIZED_ELEMENTS[containerId];
            s7videoviewer.dispose();
            delete ResponsiveVideo.INITIALIZED_ELEMENTS[containerId];
        }

        s7videoviewer = new s7viewers.VideoViewer({
            'containerId': containerId,
            'params': params,
            'handlers': {
                'initComplete': function() {
                    element.classList.add(ResponsiveVideo.INITIALIZED_CLASS);
                    ResponsiveVideo.INITIALIZED_ELEMENTS[containerId] = s7videoviewer;
                    if (onInitCallback && {}.toString.call(onInitCallback) === '[object Function]') {
                        onInitCallback();
                    }
                }
            }
        });

        s7videoviewer.init();
    },

    getAssetSource(asset, paramName) {
        if (!asset || !paramName) {
            return null;
        }

        if (asset.indexOf(ResponsiveVideo.VIDEOVIEWER_URL) > -1) {
            asset = asset.replace(ResponsiveVideo.VIDEOVIEWER_URL, '');
            asset = asset.replace('?', '');
            var urlParams = JSON.parse('{"' + asset.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
                function(key, value) {return key === '' ? value : decodeURIComponent(value);});
            asset = urlParams[paramName];
        }

        if (!asset) {
            return null;
        }

        if (asset.indexOf(ResponsiveVideo.DEFAULT_LINKS_CONFIG.contenturl) > -1) {
            asset = asset.replace(ResponsiveVideo.DEFAULT_LINKS_CONFIG.contenturl, '');
        }

        if (asset.indexOf(ResponsiveVideo.DEFAULT_LINKS_CONFIG.serverurl) > -1) {
            asset = asset.replace(ResponsiveVideo.DEFAULT_LINKS_CONFIG.serverurl, '');
        }

        if (asset.indexOf(ResponsiveVideo.VIDEO_FIRST_PART) == 0) {
            return asset;
        }

        return null;
    },
    getAssetConfig(element) {
        try {
            return JSON.parse(element.dataset[ResponsiveVideo.CONFIG]);
        } catch(e) {
            return {};
        }
    },
};

window.addEventListener('dm.video.init', function (e) {
    ResponsiveVideo.renitializeElement(e.detail.element, e.detail.config, e.detail.onInitCallback);
});

window.addEventListener('scroll', function () {
    if (!ResponsiveVideo.IS_LOADED) {
        ResponsiveVideo.IS_LOADED = true;
        ResponsiveVideo.init(false);
    }
});

window.addEventListener('DOMContentLoaded', function () {
    ResponsiveVideo.init(true);
});
